













import { Component, Vue} from 'vue-property-decorator';
// import { Account, NetworkType } from 'nem2-sdk';
// import { Apostille, ApostilleHttp, HistoricalEndpoints } from 'apostille-library';
// import { CreationMessage } from '@luxtag/luxtag-sdk-ts';

@Component
export default class Secret extends Vue {
    public currentCertPK = '';
    public currentCertPB = '';
    public currentAddress = '';
    public account = null;

    public generate() {
        // const seed = Math.random().toString(36).substring(7) + Math.floor((Math.random() * 99999) + 1);
        // const apostille = Apostille.init(seed, this.account);

        // const name = `Random ${Math.floor(
        //             (Math.random() * 100) + 1)}-${Math.floor((Math.random() * 50) + 1)}`;

        // const data = {
        //     content: {
        //         'Serial Number': `A1000${Math.floor(
        //             (Math.random() * 100) + 1)}-${Math.floor((Math.random() * 50) + 1)}`,
        //         'Product': `Awesome ${Math.floor(
        //             (Math.random() * 100) + 1)}-${Math.floor((Math.random() * 50) + 1)}`,
        //     },
        //     imgs: [
        //         `https://picsum.photos/510/300/?image=${Math.floor((Math.random() * 10) + 1)}`,
        //         `https://picsum.photos/510/300/?image=${Math.floor((Math.random() * 10) + 1)}`,
        //     ],
        // };

        // const creationMessage = new CreationMessage(
        //     seed,
        //     name,
        //     data
        // );

        // const creationTransaction = apostille.apostillePublicAccount.update(creationMessage.toString(), []);
        // const signedTransaction = apostille.apostillePublicAccount.sign(creationTransaction, this.account);

        // const apostilleHttp = new ApostilleHttp(HistoricalEndpoints[apostille.HDAccount.address.networkType]);
        // apostilleHttp.announce(signedTransaction).then((res) => {
        //     console.log(res);
        //     this.currentCertPK = apostille.HDAccount.privateKey;
        //     this.currentCertPB = apostille.HDAccount.publicKey;
        //     this.currentAddress = apostille.HDAccount.address.plain();
        // }).catch((err: any) => {
        //     console.error(err);
        // });

    }
}
